import React from 'react';

import { ReactComponent as Check } from 'assets/icons/green-check.svg';

const TrustedContactInstructionContent = {
  title: "Add a Trusted Contact",
  subtitle: "Trusted Contacts are persons whom you authorize T. Rowe Price to contact if there is a reasonable belief that your account may be exposed to possible financial exploitation or fraud.",
  stepTitle: "You will need:",
  steps: [],
  notes: [
    {
      content: "Your trusted contact’s name and phone number",
      icon: <Check />
    }
  ]
};

export default TrustedContactInstructionContent;
